module.exports = __webpack_public_path__ + "media/svg-new/book-815b0729.svg";